import React, { useEffect, useState } from "react";

import {
  Alert,
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import EmailIcon from '@mui/icons-material/Email';

import MailIcon from "@mui/icons-material/Mail";
import SendIcon from "@mui/icons-material/Send";
import PersonIcon from "@mui/icons-material/Person";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import MessageIcon from "@mui/icons-material/Message";
import CloseIcon from "@mui/icons-material/Close";

import { toast } from "react-toastify";
import { createEnquiry } from "../API/apiconst";


interface FormData {
  name: string;
  email: string;
  phoneNumber: string;
  purpose: string;
  message: string;
}



interface HomeContactProps {
  purpose?: string;
  closeModal?: () => void;
}
  
const ContactButton: React.FC<HomeContactProps> = ({
  purpose = "CATIA CAA Inquiry",
  closeModal,
}) => {
  
  const [open, setOpen] = useState(false);

   const [modal, setModal] = useState<boolean>(false);
  

  
    const [formData, setFormData] = useState<FormData>({
      name: "",
      email: "",
      phoneNumber: "",
      purpose: purpose,
      message: "",
    });
  
useEffect(()=>{

setFormData(prev=>({
...prev,
purpose
}));

},[purpose]);
  
    const [success, setSuccess] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
      const [onclose, setOnclose] = useState<((open: boolean) => void) | null>(null);
  
  const [modalTitle, setModalTitle] = useState("");
    const toggle = () => setModal(!modal);
    const [selectedPurpose, setSelectedPurpose] = useState("");
  
  const openModal = (type: string) => {
    setSelectedPurpose(type);
    setModalTitle(type);
    setModal(true);
  };
    
  
  
  
    // INPUT CHANGE
const handleChange=(e:any)=>{

const {name,value}=e.target;

setFormData(prev=>({

...prev,
[name]:value

}));

};
  
  
  
  const handleSubmit=async(e:any)=>{

e.preventDefault();

setLoading(true);

try{

await createEnquiry(formData);

setSuccess(true);
setError(false);

toast.success("Form submitted successfully!");

setFormData({

name:"",
email:"",
phoneNumber:"",
purpose,
message:""

});

setTimeout(()=>{

setOpen(false);

},1000);

}
catch{

setSuccess(false);
setError(true);

toast.error("Failed to submit");

}
finally{

setLoading(false);

}

};

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setOpen(true)}
        style={{
          position: "fixed",
          right: "25px",
          bottom: "25px",
          zIndex: 9999,
          background: "linear-gradient(135deg,#00c6ff,#0072ff)",
          color: "#fff",
          padding: "14px 22px",
          border: "none",
          borderRadius: "50px",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          fontWeight: 700,
          fontSize: "16px",
          cursor: "pointer",
          boxShadow: "0 8px 25px rgba(0,0,0,0.35)",
        }}
      >
        Contact Us
      </button>

      {/* Background Overlay */}
      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 9998,
          }}
        />
      )}

      {/* Right Side Modal */}
      <div
  style={{
    position: "fixed",
    top: 0,
    right: open ? 0 : "-500px",
    width: "500px",
    maxWidth: "100%",
    height: "55vh",
    background: "#0f172a",
    zIndex: 9999,
    transition: "right 0.35s ease",
    boxShadow: "-8px 0 30px rgba(0,0,0,.4)",
    overflowY: "auto",
    marginTop:"300px",
   borderRadius: "20px",
  borderWidth: "1px",
  borderStyle: "solid", // required for the border to appear
  borderColor: "white",
  }}
>


  {/* Body */}
  <div style={{ padding: "25px", borderRadius:"" }}>
    {/* {success && (
      <Alert color="success">
        Email sent successfully!
      </Alert>
    )}

    {error && (
      <Alert color="danger">
        Failed to send email.
      </Alert>
    )} */}

    <Form onSubmit={handleSubmit}>
      <Row>

        {/* Name */}
        <Col md={12}>
          <FormGroup>
            <div className="input-wrapper">
              <PersonIcon className="input-icon" />
              <Input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                className="custom-input"
                required
              />
            </div>
          </FormGroup>
        </Col>

        {/* Email */}
        <Col md={12}>
          <FormGroup>
            <div className="input-wrapper">
              <EmailIcon className="input-icon" />
              <Input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className="custom-input"
                required
              />
            </div>
          </FormGroup>
        </Col>

        {/* Phone */}
        <Col md={12}>
          <FormGroup>
            <div className="input-wrapper">
              <LocalPhoneIcon className="input-icon" />
              <Input
                type="text"
                name="phoneNumber"
                placeholder="Phone Number"
                value={formData.phoneNumber}
                onChange={handleChange}
                className="custom-input"
                required
              />
            </div>
          </FormGroup>
        </Col>

        {/* Purpose */}
        <Col md={12}>
          <FormGroup>
            <Input
  type="hidden"
  name="purpose"
  value={formData.purpose}
/>
          </FormGroup>
        </Col>

        {/* Message */}
        <Col md={12}>
          <FormGroup>
            <div className="input-wrapper">
              <MessageIcon className="input-icon" />
              <Input
                type="textarea"
                rows={5}
                name="message"
                placeholder="Describe your requirements..."
                value={formData.message}
                onChange={handleChange}
                className="custom-input custom-textarea"
                required
              />
            </div>
          </FormGroup>
        </Col>

        {/* Submit */}
        <Col md={12}>
          <Button
            color="primary"
            type="submit"
             className="primary-btn"
            disabled={loading}
            style={{
              width: "50%",
              height: "55px",
              borderRadius: "12px",
              fontWeight: 600,
              marginLeft:"20%",
              marginTop:"10px"
            }}
          >
            {loading ? (
              "Sending..."
            ) : (
              <span
             
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <SendIcon />
                Send 
              </span>
            )}
          </Button>
        </Col>

      </Row>
    </Form>
  </div>
</div>
    </>
  );
};
export default ContactButton;

const inputStyle = {
  width: "100%",
  padding: "12px",
  marginBottom: "15px",
  border: "1px solid #ddd",
  borderRadius: "8px",
  fontSize: "15px",
  boxSizing: "border-box" as const,
};


